import api from '../Api/api';
import { Apis } from '../Api/config';
import { NotificationManager } from "react-notifications";
import { setCookie } from "../jwt/function";
import i18n from 'src/i18n';

const UserLogin = async (data) => {
    try {
        let result = await api.post(Apis.UserLoginAPI, data, {
            withCredentials: false,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                withCredentials: false,
                changeOrigin: true,
            },
        });

        // Vérifier si c'est une erreur (success: false)
        if (result.data.success === false) {
            NotificationManager.error(i18n.t(result.data.message));
            return null;
        }

        // Si c'est un succès (success: true) ou l'ancien format sans 'success'
        if (result.data.error) {
            NotificationManager.error(i18n.t(result.data.error));
            return null;
        }

        return result.data;

    } catch (error) {
        console.error('Login API error:', error.response);
        if (error.response) {
            const backendError = error.response.data;

            if (backendError.message) {
                NotificationManager.error(i18n.t(backendError.message));
            } else if (backendError.error) {
                NotificationManager.error(i18n.t(backendError.error));
            } else {
                NotificationManager.error(i18n.t('loginError'));
            }
        } else if (error.request) {
            NotificationManager.error(i18n.t('networkError'));
        } else {
            NotificationManager.error(i18n.t('configurationError'));
        }

        return null;
    }
};

const UserLoginEmploye = async (data) => {
    try {
        let result = await api.post(Apis.UserLoginEmployeAPI, data, {
            withCredentials: false,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                withCredentials: false,
                changeOrigin: true,
            },
        });

        // Même logique pour UserLoginEmploye
        if (result.data.success === false) {
            NotificationManager.error(i18n.t(result.data.message));
            return null;
        }

        if (result.data.error) {
            NotificationManager.error(i18n.t(result.data.error));
            return null;
        }

        return result.data;

    } catch (error) {
        console.error('Employee login API error:', error);

        if (error.response) {
            const backendError = error.response.data;
            if (backendError.message) {
                NotificationManager.error(i18n.t(backendError.message));
            } else if (backendError.error) {
                NotificationManager.error(i18n.t(backendError.error));
            } else {
                NotificationManager.error(i18n.t('loginError'));
            }
        } else if (error.request) {
            NotificationManager.error(i18n.t('networkError'));
        } else {
            NotificationManager.error(i18n.t('configurationError'));
        }

        return null;
    }
};

const authenticate = (user, next) => {
    const token = user.token || user.accessToken;
    if (token) {
        localStorage.setItem('@accessToken', token);
        if (typeof window !== "undefined") {
            setCookie("@token_session", token, 10);
        }
    }
    if (next && typeof next === 'function') {
        next();
    }
};

const GET_Role = () => {
    try {
        const token = localStorage.getItem('@accessToken');
        if (token) {
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload.privilege || [];
        }
    } catch (error) {
        console.error('Error decoding token:', error);
    }
    return [];
};

const logout = () => {
    localStorage.removeItem('@accessToken');
};

// Étape 1/2 : demande de réinitialisation de mot de passe par email.
// La réponse du back-end est volontairement générique (elle ne révèle
// jamais si l'email existe ou non), on affiche donc toujours un message
// de succès neutre au lieu du contenu retourné par l'API.
const ForgotPassword = async (email) => {
    try {
        await api.post(Apis.api_ForgotPassword, { email });
        NotificationManager.success(i18n.t('resetPasswordEmailSentIfExists'));
        return true;
    } catch (error) {
        console.error('ForgotPassword API error:', error);
        NotificationManager.error(i18n.t('networkError'));
        return false;
    }
};

// Étape 2/2 : soumission du nouveau mot de passe avec le token reçu par email.
const ResetPassword = async ({ id, token, password, type }) => {
    try {
        const result = await api.post(
            Apis.api_ResetPassword,
            {
                id,
                token,
                password,
                type
            }
        );

        if (result.data.success === false) {
            NotificationManager.error(
                i18n.t(
                    result.data.message || 'invalidOrExpiredToken'
                )
            );
            return false;
        }

        NotificationManager.success(
            i18n.t('passwordResetSuccess')
        );

        return true;

    } catch (error) {
        console.error('ResetPassword API error:', error);

        const backendError = error.response?.data;

        NotificationManager.error(
            i18n.t(
                backendError?.message ||
                backendError?.error ||
                'invalidOrExpiredToken'
            )
        );

        return false;
    }
};

const LoginFun = {
    UserLogin,
    authenticate,
    GET_Role,
    logout,
    UserLoginEmploye,
    ForgotPassword,
    ResetPassword
};

export default LoginFun;